import React, { Component } from 'react';
import { connect } from 'react-redux';
import UserList from "./UserList";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import * as _ from 'lodash';
import {canManageUsers, canViewUsers} from "../../PermissionSelectors";
import Pagination from "../navigation/Pagination";
import {exportUserList} from "../../requests/UserRequests";
import {faChevronDown, faSearch} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class ListUsersPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: [],
      status: 'all',
      search: '',
      profile: null,
      currentPage: 1,
      userCount: 0,
    };

    this.getUsers = this.getUsers.bind(this);
    this.profileFilterChange = this.profileFilterChange.bind(this);
    this.statusFilterChange = this.statusFilterChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.exportUsers = this.exportUsers.bind(this);
    this.goTo = this.goTo.bind(this);
    this.onSearchChangeDebounce = _.debounce((value) => {
      this.setState({ search: value, currentPage: 1 }, () => {
        this.getUsers();
      });
    }, 400);
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers() {
    return this.props.getUsers(this.state.status, this.state.profile, this.state.search, this.state.currentPage).then((response) => {
      this.setState({ users: response.data, userCount: response.total });
    })
  }

  profileFilterChange(event) {
    this.setState({ profile: event.target.value, currentPage: 1 }, () => {
      this.getUsers();
    });
  }

  statusFilterChange(event) {
    this.setState({ status: event.target.value, currentPage: 1 }, () => {
      this.getUsers();
    });
  }

  onSearchChange = event => {
    this.onSearchChangeDebounce(event.target.value);
  };


  goTo(page){
    this.setState({
      currentPage: page
    }, () => {
      this.getUsers();
    });
  }
  
  exportUsers(){
    exportUserList()
  }

  render() {
    return <div className={"container"}>
      {
        (this.props.canViewUsers) ?
          <div>
            <div className={"row"}>
              <div className="col-12 col-md-3 d-flex">
                <input type={"text"} className={"form-control"} placeholder={"Search by name, account, etc."}
                  onChange={this.onSearchChange} />
                <div className="search ml-2 mr-1">
                  <FontAwesomeIcon icon={faSearch} size={"lg"}/>
                </div>
              </div>
              <div className="col-12 col-md-3">
                <div className="customSelect">
                  <select onChange={this.statusFilterChange} value={this.state.status} className={"form-control"}>
                    <option value="all">All Statuses</option>
                    <option value="active">Active</option>
                    <option value="deactive">Deactive</option>
                    <option value="locked">Locked</option>
                    <option value="waiting-confirmation">Waiting Confirmation</option>
                  </select>
                  <span className="select-arrow">
                    <FontAwesomeIcon icon={faChevronDown}/>
                  </span>
                </div>
              </div>
              <div className="col">
              </div>
              { /* TODO: not needed for schindler */ }
              {/*<div className="col-12 col-md-3">*/}
                {/*<div className="customSelect">*/}
                  {/*<select onChange={this.profileFilterChange} value={this.state.profile} className={"form-control"}>*/}
                    {/*<option value="all">All Profiles</option>*/}
                    {/*<option value="1">Sold To</option>*/}
                    {/*<option value="2">Payer</option>*/}
                    {/*<option value="3">Payer - All</option>*/}
                  {/*</select>*/}
                  {/*<span className="select-arrow">*/}
                    {/*<i className="fas fa-chevron-down"></i>*/}
                  {/*</span>*/}
                {/*</div>*/}
              {/*</div>*/}
              <div className="col-12 col-md-2">
                {this.props.canManageUsers && <Link exact to={"/settings/users/add"}>
                  <button className="btn btn-primary btn-block">Add User</button>
                </Link>}
              </div>
              <div className="col-12 col-md-1 d-flex align-items-center">
                <span>{this.state.users ? this.state.userCount : '0'} Users</span>
              </div>
              <div className="col d-flex justify-content-end">
                <button className={"btn btn-secondary user-export-button"} onClick={this.exportUsers}>Export Users</button>
              </div>
            </div>
            <div className={"row mt-4"}>
              <div className={"col-12"}>
                <UserList users={this.state.users} />
              </div>
            </div>
            <div className={"row mt-4"}>
              <div className={"col-12"}>
                <Pagination goTo={this.goTo} currentPage={this.state.currentPage} totalItems={this.state.userCount}/>
              </div>
            </div>
          </div>
          : null
      }
    </div>
  }
}

ListUsersPage.propTypes = {
  getUsers: PropTypes.func.isRequired,
};

export default connect((state, props) => ({
  canManageUsers: canManageUsers(state, props),
  canViewUsers: canViewUsers(state, props),
}))(ListUsersPage);
